import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientHelperService } from '../http-client-helper.service';
import { DomainGroupPendingChangesResponse, DomainGroupResponse, DomainGroupStyle, DomainGroupUpdateRequest, ExtendedDomainGroupResponse } from '../models/cmp/domain-group.interface';
import { QuickSetupRequest } from '../models/cmp/quick-setup.interface';
        
@Injectable({
  	providedIn: 'root'
})
export class ApiClientCmpDomainGroupsService {

	private readonly controller = 'cmp';
	private readonly version = 'v1';

  	constructor(private httpClientHelper: HttpClientHelperService) { }

	getDomainGroups(): Observable<DomainGroupResponse[]> {
        return this.httpClientHelper.invokeGetAuth<DomainGroupResponse[]>(`${this.controller}/${this.version}/domain-groups`);
	}

	getDomainGroupById(domainGroupId: string): Observable<ExtendedDomainGroupResponse> {
        return this.httpClientHelper.invokeGetAuth<ExtendedDomainGroupResponse>(`${this.controller}/${this.version}/domain-groups/${domainGroupId}`);
	}

	getPendingChanges(domainGroupId: string): Observable<DomainGroupPendingChangesResponse> {
        return this.httpClientHelper.invokeGetAuth<DomainGroupPendingChangesResponse>(`${this.controller}/${this.version}/domain-groups/${domainGroupId}/pending-changes`);
	}

	createDomainGroup(name: string): Observable<DomainGroupResponse> {
        return this.httpClientHelper.invokePostAuth<DomainGroupResponse>(`${this.controller}/${this.version}/domain-groups`, { name });
	}

	updateDomainGroup(domainGroupId: string, request: DomainGroupUpdateRequest): Observable<ExtendedDomainGroupResponse> {
        return this.httpClientHelper.invokePatchAuth<ExtendedDomainGroupResponse>(`${this.controller}/${this.version}/domain-groups/${domainGroupId}`, request);
	}

	updateDomainGroupStyle(domainGroupId: string, style: DomainGroupStyle): Observable<void> {
        return this.httpClientHelper.invokePutAuth<void>(`${this.controller}/${this.version}/domain-groups/${domainGroupId}/style`, style);
	}

	deleteDomainGroup(domainGroupId: string): Observable<void> {
        return this.httpClientHelper.invokeDeleteAuth<void>(`${this.controller}/${this.version}/domain-groups/${domainGroupId}`);
	}

	publishDomainGroup(domainGroupId: string): Observable<void> {
        return this.httpClientHelper.invokePostAuth<void>(`${this.controller}/${this.version}/domain-groups/${domainGroupId}/publish`);
	}

	bootstrap(domainGroupId: string, request: QuickSetupRequest): Observable<void> {
		return this.httpClientHelper.invokePostAuth<void>(`${this.controller}/${this.version}/domain-groups/${domainGroupId}/bootstrap`, request);
	}
}

